import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

const Navigation = () => {
  return (
    <>
      <DesktopNav />
      <MobileNav />
    </>
  );
};

export default Navigation;
